<template>
  <el-dialog width="380px" :visible="isShow" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 批量移动物料表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <el-button type="primary" size="mini" plain round icon="em-icon-save" @click="handlerSave"> 提交保存</el-button>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div style="position: absolute; padding-top: 20px; top: 33px; right: 0; left:0; height: 300px; background: #fff;">
      <el-form size="mini" label-width="80px" :show-message="false">
        <!--编辑时主表数据 开始-->
        <div class="form-main">
          <el-row>
            <el-col :span="24">
              <el-form-item label="物料分类">
                <el-tree-select ref="treeSelect" :value="categoryId" :label="categoryName" :options="categories" :props="treeSelectProps" @getValue="getCategoryValue($event)"></el-tree-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import ElTreeSelect from '@/components/tree-select/el-tree-select.vue'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      categoryId: '0',
      categoryName: '',
      treeSelectProps: {
        // 配置项（必选）
        value: 'id',
        label: 'name',
        children: 'children'
      },
      // 当前操作者
      operator_id: sessionStorage.getItem('operator_id'),
      categories: [],
      editable: this.$store.state.editable
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    handlerOpen: function () {
      const _this = this
      _this.post(_this.$apis.getBaseMaterialCategory, { ModelId: '0' }, function (res) {
        let _json = res.data
        _this.categories = _json.parentCategories
        _this.categoryId = _this.parent.currentCategory.id
        _this.categoryName = _this.parent.currentCategory.name
        _this.$nextTick(() => {
          _this.$refs.treeSelect.initHandler(_this.categoryId, _this.categoryName)
        })
        // 对话框显示
        _this.isShow = true
      })
    },
    getCategoryValue: function (value) {
      this.categoryId = value
    },
    // 保存
    handlerSave: function () {
      const _this = this
      // 要提交的数据
      const data = {
        categoryId: _this.categoryId,
        materialIds: _this.parent.selectedIds.join(','),
        operatorId: _this.operator_id
      }
      _this.post(_this.$apis.moveBaseMaterial, data, function (res) {
        let _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '保存成功',
            type: 'success'
          })
          _this.parent.loadMaterials()
          _this.isShow = false
        }
      })
    },
    // 关闭窗口
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    }
  },
  components: {
    ElTreeSelect
  }
}
</script>
